import { ComponentRoute } from '@/classes'

const RepxRoutes = {
  DashboardView: new ComponentRoute('/repx', 'Repx')
}

export default RepxRoutes